<template>
  <div class="lgrm-browser-wireframe">
    <div class="lgrm-browser-wireframe-wrapper">
      <div class="lgrm-window-title">
        <div class="lgrm-window-actions">
          <div class="lgrm-btn lgrm-btn-1"></div>
          <div class="lgrm-btn lgrm-btn-2"></div>
          <div class="lgrm-btn lgrm-btn-3"></div>
        </div>
        <div class="lgrm-window-address-bar">
        </div>
      </div>
      <div class="lgrm-window-content">
        <div v-if="buttonVisible" class="lgrm-feedback-button" v-bind:class="[buttonPositionClass]"
          :style="feedbackButtonStyle">

        </div>

        <div v-if="feedbackWidgetVisible" 
          class="lgrm-feedback-widget" 
          v-bind:class="[feedbackWidgetPositionClass]"
          :style="feedbackWidgetStyle"
          >
          <div class="lgrm-feedback-widget-content">
            <div class="lgrm-question-mock"></div>
            <div class="lgrm-question-mock-buttons">
              <div class="lgrm-question-mock-button" :style="getNPSButtonStyle(0)"></div>
              <div class="lgrm-question-mock-button" :style="getNPSButtonStyle(1)"></div>
              <div class="lgrm-question-mock-button" :style="getNPSButtonStyle(2)"></div>
              <div class="lgrm-question-mock-button" :style="getNPSButtonStyle(3)"></div>
              <div class="lgrm-question-mock-button" :style="getNPSButtonStyle(4)"></div>
            </div>
          </div>
        </div>

        <div v-if="proofWidgetVisible" 
          class="lgrm-proof-widget-wireframe position" 
          v-bind:class="[proofWidgetPositionClass]"
          :style="proofWidgetStyle"
          >
          <div class="lgrm-proof-widget-content">
            <div class="lgrm-proof-avatar-area" :style="getProofStyle()">
              <div class="lgrm-proof-avatar-circle" ></div>
            </div>
            <div class="lgrm-proof-data-area">
              <div class="user-details"></div>
              <div class="feedback-details"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import colorMixin from '@/mixins/colors'
export default {
  name: 'BrowserWireframe',
  mixins: [colorMixin],
  props: {
    widgetType: String,
    brandColor: String,
    buttonPosition: String,
    buttonVisible: Boolean,
    feedbackWidgetPosition: String,
    feedbackWidgetVisible: Boolean,
    proofWidgetPosition: String,
    proofWidgetVisible: Boolean, 
    previewItem: String

  },
  data: function() {
    return {
      selectedValue: 2
      
    }
  },
  computed: {
    buttonPositionClass(){
      if(this.buttonPosition === 'RIGHT_CENTER'){
        return 'right-center'
      }
      if(this.buttonPosition === 'LEFT_CENTER'){
        return 'left-center'
      }
      if(this.buttonPosition === 'BOTTOM_LEFT'){
        return 'bottom-left'
      }
      if(this.buttonPosition === 'BOTTOM_RIGHT'){
        return 'bottom-right'
      }
      return 'right-center'
    },
    feedbackWidgetPositionClass(){
      if(this.feedbackWidgetPosition === 'BOTTOM'){
        return 'bottom'
      }
      if(this.feedbackWidgetPosition === 'TOP'){
        return 'top'
      }
      if(this.feedbackWidgetPosition === 'TOP_CENTRE'){
        return 'top-center'
      }
      if(this.feedbackWidgetPosition === 'BOTTOM_CENTRE'){
        return 'bottom-center'
      }
      return 'bottom'
    },
    proofWidgetPositionClass(){
      if(this.proofWidgetPosition === 'BOTTOM_LEFT'){
        return 'bottom-left'
      }
      if(this.proofWidgetPosition === 'BOTTOM_RIGHT'){
        return 'bottom-right'
      }
      if(this.proofWidgetPosition === 'TOP_LEFT'){
        return 'top-left'
      }
      if(this.proofWidgetPosition === 'TOP_RIGHT'){
        return 'top-right'
      }
      return 'bottom-left'
    },
    feedbackButtonStyle(){
      const css = {}
      css.backgroundColor = this.brandColor
      if(this.previewItem == 'FEEDBACK_BUTTON'){
        css.zIndex = '10'
      }
      else{
        css.zIndex = 1
      }
      
      return css
    },
    feedbackWidgetStyle(){
      const css = {}
      if(this.previewItem == 'FEEDBACK_WIDGET'){
        css.zIndex = '10'
      }
      else{
        css.zIndex = '1'
      }
      
      return css
    },
    proofWidgetStyle(){
      const css = {}
      if(this.previewItem == 'FEEDBACK_WIDGET'){
        css.zIndex = '10'
      }
      else{
        css.zIndex = '1'
      }
      
      return css
    }
  },
  methods: {
    getNPSButtonStyle(value) {
      const stl = {}
      stl.border = '1px solid ' + this.brandColor
      stl.color = '#000'
      
      if (value === this.selectedValue) {
        stl.border = '1px solid ' + this.brandColor
        stl.background = this.brandColor
          if (this.isColorLighter(this.brandColor)) {
          stl.color = '#000'
        } else {
          stl.color = '#fff'
        }
      }
      else{
        if (this.npsButtonLabelColor) {
          stl.color = this.npsButtonLabelColor
        }
      }
      return stl
    },
    
    getProofStyle() {
      const stl = {}
      stl.background = this.brandColor
      return stl
    },
  }
}

</script>

<style lang="stylus">
.lgrm-browser-wireframe {
  width: 100%
  height: 100%
  max-height 300px

.lgrm-browser-wireframe-wrapper
{
  width: 100%
  height 100%
}
.lgrm-window-title {
  height 35px
  background: $color-primary-light-8
  border-top-left-radius: 5px
  border-top-right-radius: 5px
  display flex
}
.lgrm-window-actions {
  width: 70px
  margin-top: 7px
  padding-left: 20px
  .lgrm-btn {
    width: 7px
    height 7px 
    margin-right: 6px
    display inline-block
    border-radius: 50%
  }
  .lgrm-btn-1 {
    background: #FF6F31
  }
  .lgrm-btn-2 {
    background: #FFCF02
  }
  .lgrm-btn-3 {
    background: #57BB8A
  }
}
.lgrm-window-address-bar {
    max-width: 85%;
    height: 15px;
    border-radius: 3px;
    background: #fff;
    width: 85%;
    margin-right: 50px;
    margin-top 10px
  }
  .lgrm-window-content {
    background: #F5F9FD
    height: calc(100% - 50px)
    position relative
  }

  .lgrm-feedback-button {
    
    width: 30px;
    height: 8px;
    border-radius: 3px 3px 0px 0px;
    position: absolute
    transition: all .5s
    &.right-center {
      right: -10px;
      top: 50%;  
      transform: rotate(-90deg);
    }

    &.left-center {
      left: -10px;
      top: 50%;  
      transform: rotate(90deg);
    }

    &.bottom-left {
      left: 5px;
      bottom: 5px;  
    }
    &.bottom-right {
      right: 5px;
      bottom: 5px;
    }
  }

  .lgrm-feedback-widget {
    height: 70px;
    position absolute
    background: #fff
    border: 1px solid #F5F9FD
    .lgrm-feedback-widget-content {
      width 100%
      height 100%
      display flex
      align-items center
      justify-content center
      flex-direction column
    }

    .lgrm-question-mock {
      max-width: 250px;
      width: 80%
      height: 5px;
      background #F1F2F6
      border-radius: 3px;
      margin-bottom 8px
    }

    .lgrm-question-mock-button {
      width: 22px;
      height: 22px;
      border-radius: 100%
      margin: 0px 2px
      display inline-block
    }

    &.bottom {
      bottom: 0px
      width 100%
      border-bottom-left-radius: 10px
      border-bottom-right-radius: 10px
    }

    &.top {
      top: 0px
      width 100%
      
    }
    &.top-center
    {
      top: 0
      width 50%
      left: 25%
    }
        
    &.bottom-center{
      bottom: 0
      width 50%
      left: 25%
    }
  }


  .lgrm-proof-widget-wireframe {
    width: 180px;
    height: 50px;
    position absolute
    background: #fff
    border: 1px solid #F1F2F6
    border-radius 5px
    &.position {
        transition: all .5s ease;
        &.bottom-left{
            bottom: 15px
            left: 15px
        }
        &.bottom-right{
            bottom: 15px
            right: 15px
        }
        &.top-left{
            top: 15px
            left: 15px
        }
        &.top-right{
            top: 15px
            right: 15px
        }
    }

    .lgrm-proof-widget-content {
      display flex
    }

    .lgrm-proof-avatar-area {
      width: 50px;
      height: 48px;
      background: #FA6B6B;
      border-radius: 5px 0px 0px 5px;
      display: flex
      align-items center
      justify-content center
      .lgrm-proof-avatar-circle {
        width: 35px;
        height: 35px;
        background: #FFFFFF;
        border-radius 50%
      }
    }
    .lgrm-proof-data-area {
      width: auto
      height: 48px;
      padding: 10px
      border-radius: 0px 5px 5px 0px;
      .user-details {
        width: 60px;
        height: 5px;
        background: #F1F2F6;
        border-radius: 3px;
        margin-bottom 10px
      }
      .feedback-details {
        width: 100px;
        height: 14px;
        background: #F5F9FD;
        border-radius: 3px;
      }
    }
  }
}
</style>
